import { useEffect, useRef, useState } from 'react';

export default function WhoItsFor() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const useCases = [
    {
      title: 'Hallway Response',
      description: 'Dictate your objection before the elevator closes.',
      delay: '0ms',
    },
    {
      title: 'Midnight Brief',
      description: '11pm, trial tomorrow. Pace your kitchen talking. We handle the rest.',
      delay: '200ms',
    },
    {
      title: 'Volume Grind',
      description: 'Twenty interrogatories. Four minutes each instead of forty.',
      delay: '400ms',
    },
  ];

  return (
    <section ref={sectionRef} className="relative py-32 bg-[#09090b]">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="text-center mb-16">
          <h2
            className={`text-white text-[26px] sm:text-[40px] lg:text-[56px] font-bold leading-tight mb-6 px-2 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            For lawyers who can't afford to wait
          </h2>
          <p
            className={`text-[#d4d4d8] text-[15px] sm:text-[20px] max-w-[700px] mx-auto px-2 transition-all duration-700 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            Solo practitioners. Firms small and large. Litigators who bill for thinking, not typing
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {useCases.map((useCase, index) => (
            <div
              key={index}
              className={`group bg-gradient-to-br from-[#18181b] to-[#1f1f23] border border-[#27272a] rounded-2xl p-6 sm:p-10 hover:border-[#06b6d4] hover:shadow-[0_0_30px_rgba(6,182,212,0.15)] hover:-translate-y-2 transition-all duration-300 cursor-pointer ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: useCase.delay }}
            >
              <h3 className="text-white text-[20px] sm:text-[26px] font-bold mb-4 group-hover:text-[#06b6d4] transition-colors">
                {useCase.title}
              </h3>
              <p className="text-[#a1a1aa] text-[14px] sm:text-[17px] leading-relaxed">
                {useCase.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
